/* eslint-disable vue/no-parsing-error */
<template>
  <div class="report-reason">
    <div class="guide-header">
      <span>【所提供的信息我们将与售卖商品账号真实信息进行校验，请保证真实性】</span>
    </div>
    <div class="guide-title"><span>为确保您的在线验货顺利通过，请依次上传以下截图：</span></div>
    <div class="guide-detial "><span>1、游戏授权所用的微信号/QQ号的个人信息页（必传）</span></div>
    <div class="guide-detial"><span>2、游戏登录授权页面</span></div>
    <div class="guide-detial"><span>3、游戏首页截图（必传）</span></div>
    <div class="guide-detial"><span>4、游戏中的个人信息页（必传）</span></div>

    <div class="guide-title">
      <span><b>以王者荣耀为例：</b></span>
    </div>
    <div class="guide-tip"><span>1、游戏授权所用的微信号/QQ号的个人信息页（必传）</span></div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="10">
        <img
          v-bind:src="$setPicSize(imgList[0])"
          @click="showBig(0)"
          width="100%"
          alt="加载中..."
        />
      </Col>
      <Col span="10">
        <img
          v-bind:src="$setPicSize(imgList[1])"
          @click="showBig(1)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
    <div class="guide-tip"><span>2、游戏登录授权页面</span></div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="10">
        <img
          v-bind:src="$setPicSize(imgList[2])"
          @click="showBig(2)"
          width="100%"
          alt="加载中..."
        />
      </Col>
      <Col span="10">
        <img
          v-bind:src="$setPicSize(imgList[3])"
          @click="showBig(3)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
    <div class="guide-tip"><span>3、游戏首页截图（必传）</span></div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="22"
        ><img
          v-bind:src="$setPicSize(imgList[4])"
          @click="showBig(4)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
    <div class="guide-tip"><span>4、游戏中的个人信息页（必传）</span></div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="22"
        ><img
          v-bind:src="$setPicSize(imgList[5])"
          @click="showBig(5)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col, ImagePreview } from '@zz-common/zz-ui'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
// import { lego } from '@zz-common/lego'
// import { toast } from '../../../native'
import { queryParams } from '../../../lib/utils'

const query = queryParams()

const tip1Left = 'https://pic1.zhuanstatic.com/zhuanzh/n_v2db58cddab57842a58e15a5078be5c829.jpg'
const tip1Right = 'https://pic2.zhuanstatic.com/zhuanzh/n_v273ac14c37da7470f8bb7bdc03f5414ac.jpg'

const tip2Left = 'https://pic3.zhuanstatic.com/zhuanzh/n_v2d97884585b924fd7ad662ff0fbadf0c5.jpg'
const tip2Right = 'https://pic4.zhuanstatic.com/zhuanzh/n_v2ea8c23d3fa6149629083f6ee61301da0.jpg'

const tip3 = 'https://pic5.zhuanstatic.com/zhuanzh/n_v2f35f44d4a7574286839d8f5f040fee18.jpg'
const tip4 = 'https://pic6.zhuanstatic.com/zhuanzh/n_v2dbcdac9aa6214751a57cf9ddec8cab5c.jpg'
export default {
  name: 'uploadExample',
  data() {
    return {
      from: query.from || this.$route.query.from, //  用户页面是2，商品页面是1，短视频页面是7，私信文字页面是4
      reasonId: query.reasonId || this.$route.query.reasonId,
      beReportedUid: query.bereporteduid || this.$route.query.bereporteduid,
      infoId: query.infoid || this.$route.query.infoid,
      videoId: query.videoId || this.$route.query.videoId,
      imgList: [tip1Left, tip1Right, tip2Left, tip2Right, tip3, tip4]
    }
  },
  components: { Col, Row },
  computed: {},
  methods: {
    showBig(startPosition) {
      ImagePreview({
        images: this.imgList,
        startPosition,
        adaptApp: true
      })
    },
    closePage() {
      native.close()
    },
    $setPicSize(url) {
      return setPicSize(url, 400, 400)
    }
  },
  mounted() {
    native.setTitle({
      title: '在线验货凭证说明'
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  },
  beforeRouteUpdate(to, _from, _next) {
    this.reasonId = to.query.reasonId
  }
}
</script>

<style scoped lang="less">
  @import 'uploadExample.less';
</style>
